<template>
  <app-layout>
    <app-layout-header></app-layout-header>
    <app-layout-body>
      <app-layout-sub title="账号设置" :menus="menus"></app-layout-sub>
    </app-layout-body>
  </app-layout>
</template>

<script>
import AppLayoutSub from '@/components/AppLayoutSub'

export default {
  name: 'AppLayoutWorkbench',
  components: {
    AppLayoutSub
  },

  data () {
    return {
      menus: this.findRoutes('Setting')
    }
  },

  methods: {
    findRoutes (routeName) {
      const { routes } = this.$router.options

      for (const route of routes) {
        if (route.name === routeName) {
          return route.children
        }
      }

      return []
    }
  }
}
</script>
